import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import toast from 'react-hot-toast';
import { THEME_MESSAGES } from 'utils/constants';
import { fetchPayoutAccounts } from 'api/admin/businesses/businesses';
import { ApiError } from 'types/api';

interface GetPayoutAccountsForBusinessOutput {
  success: boolean;
  payoutAccounts: Array<{
    id: number;
    accountId: string;
    default: boolean;
    stores: any[];
    accountName?: string;
    accountLast4?: string;
    routingNumber?: string;
    isVerified: boolean;
    cardPayments: string;
    transfers: string;
    achPayments: string;
    statementDescriptor?: string;
    requirementStatus: string;
  }>;
  total: number;
}

export type PayoutAccount = GetPayoutAccountsForBusinessOutput['payoutAccounts'][0];

export const usePayoutAccountsForBusiness = (
  businessId: string | number,
  enabled: boolean = true,
) => {
  return useQuery<unknown, ApiError, PayoutAccount[]>({
    queryKey: ['payoutAccountsForBusiness', businessId],
    queryFn: async () => {
      if (!businessId) {
        return [];
      }

      const { data } = (await fetchPayoutAccounts(
        businessId,
      )) as AxiosResponse<GetPayoutAccountsForBusinessOutput>;
      return data.payoutAccounts ?? [];
    },
    onError: (error) => {
      Sentry.captureException(error);

      toast.error(error?.response?.data?.error ?? THEME_MESSAGES.somethingWrong, {
        duration: 4000,
      });
      return error;
    },
    enabled: enabled && !!businessId,
    initialData: [],
  });
};
